import { createAction, createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  BrandsState,
  AddCompetitorPayload,
  DeleteCompetitorPayload,
  ChangeCompetitorStatusPayload,
  UpdateBrandPayload,
  FetchAddNewBrandCompetitorsPayload,
} from "./types";
import { Brand } from "../../types/brand";
import { CompetitorWithLogo } from "../../types/competitor";



export const initialState: BrandsState = {
  loading: false,
  loadError: null,
  selectedBrandId: undefined,
  viewBrandId: null,
  listBrands: null,
  brand: null,
  competitors: null,
  addNewBrand: {
    loading: false,
    brand: null,
    competitors: null,
    selectedCompetitors: null,
  },
};

const brandsSlice = createSlice({
  name: "brands",
  initialState,
  reducers: {
    setBrandsLoading: (state) => {
      state.loading = true;
      state.loadError = null;
    },
    setSelectedBrandId: (state, action) => {
      state.selectedBrandId = action.payload;
    },
    setViewBrandId: (state, action: PayloadAction<number | null>) => {
      state.viewBrandId = action.payload;
    },

    fetchBrandsSuccess: (state) => {
      state.loading = false;
      state.loadError = null;
    },
    fetchBrandFailure: (state, action: PayloadAction<string | undefined>) => {
      state.loading = false;
      state.loadError = action.payload ?? null;
    },

    updateBrandSuccess: (state) => {
      state.loading = false;
    },
    updateBrandFailure: (state) => {
      state.loading = false;
    },

    fetchBrandSuccess: (state, action) => {
      state.loading = false;
      if (action.payload.brand !== undefined) {
        state.brand = action.payload.brand;
      }
      state.competitors = action.payload.competitors;
    },

    fetchListBrandsSuccess: (state, action) => {
      state.listBrands = action.payload;
      state.loadError = null;
    },

    addCompetitorSuccess: (state) => {
      state.loading = false;
    },
    addCompetitorFailure: (state) => {
      state.loading = false;
    },

    deleteCompetitor: (state, action) => {
      if (!state.competitors) return;
      
      state.competitors = state.competitors.filter(
        (competitor: Brand) => competitor.id !== action.payload.id
      );
    },

    deleteCompetitorSuccess: (state) => {
      state.loading = false;
    },
    deleteCompetitorFailure: (state) => {
      state.loading = false;
    },

    changeCompetitorStatusSuccess: (state) => {
      state.loading = false;
    },
    changeCompetitorStatusFailure: (state) => {
      state.loading = false;
    },

    setAddNewBrandBrand: (state, action) => {
      state.addNewBrand.brand = action.payload;
    },
    setAddNewBrandCompetitors: (state, action: PayloadAction<CompetitorWithLogo[]>) => {
      state.addNewBrand.competitors = action.payload;
    },
    setAddNewBrandSelectedCompetitors: (state, action: PayloadAction<CompetitorWithLogo[]>) => {
      state.addNewBrand.selectedCompetitors = action.payload;
    },


    setAddNewBrandLoading: (state) => {
      state.addNewBrand.loading = true;
    },

    fetchAddNewBrandCompetitorsSuccess: (state, action: PayloadAction<CompetitorWithLogo[]>) => {
      state.addNewBrand.loading = false;
      state.addNewBrand.competitors = action.payload;
    },
    fetchAddNewBrandCompetitorsFailure: (state) => {
      state.addNewBrand.loading = false;
    },
    resetAddNewBrand: (state) => {
      state.addNewBrand = initialState.addNewBrand;
    },
  },
});



export const createNewBrand = createAction('brands/createNewBrand');
export const fetchBrands = createAction('brands/fetchBrands');
export const fetchAddNewBrandCompetitors = createAction<FetchAddNewBrandCompetitorsPayload>('brands/fetchAddNewBrandCompetitors');
export const updateBrand = createAction<UpdateBrandPayload>('brands/updateBrand');
export const addCompetitor = createAction<AddCompetitorPayload>('brands/addCompetitor');
export const changeCompetitorStatus = createAction<ChangeCompetitorStatusPayload>('brands/changeCompetitorStatus');
export const deleteCompetitor = createAction<DeleteCompetitorPayload>('brands/deleteCompetitor');
export const fetchSelectedBrandId = createAction<string | undefined>('brands/fetchSelectedBrandId');
export const fetchSelectedBrandIdSuccess = createAction<number | undefined>('brands/fetchSelectedBrandIdSuccess');
export const updateSelectedBrandId = createAction<number>('brands/updateSelectedBrandId');



export const {
  fetchBrandsSuccess,
  fetchBrandSuccess,
  fetchBrandFailure,
  setBrandsLoading,
  addCompetitorSuccess,
  addCompetitorFailure,
  deleteCompetitorSuccess,
  deleteCompetitorFailure,
  changeCompetitorStatusSuccess,
  changeCompetitorStatusFailure,
  updateBrandSuccess,
  updateBrandFailure,
  fetchListBrandsSuccess,
  setSelectedBrandId,
  setViewBrandId,
  setAddNewBrandBrand,
  setAddNewBrandCompetitors,
  setAddNewBrandSelectedCompetitors,
  fetchAddNewBrandCompetitorsSuccess,
  fetchAddNewBrandCompetitorsFailure,
  resetAddNewBrand,
  setAddNewBrandLoading,
} = brandsSlice.actions;

export default brandsSlice.reducer;
